module.exports = __webpack_public_path__ + "static/media/hidato_promo.799a7afe.png";